export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "Spreadsheet",
  language: "Sprache",
  nav: {
    spreadsheet: "Spreadsheet",
    categories: "Kategorien",
    reviews: "Bewertungen",
    shipping: "Versand",
    qc: "QC",
    safety: "Sicherheit",
    guides: "Guides",
    home: "Startseite",
    shoppingGuide: "Einkaufs-Guide",
    mobileCategories: "Kategorien durchsuchen",
  },
  cta: {
    explore: "AllChinaBuy Spreadsheet erkunden",
    visitMain: "Hauptwebsite besuchen",
    buyNow: "Jetzt kaufen",
    viewAll: "Alle Kategorien ansehen",
    readGuide: "Guide lesen",
    readArticle: "Vollständigen Guide lesen",
    backHome: "Zurück zur Startseite",
  },
  trust:
    "Unabhängige Informationsressource • Regelmäßig aktualisiert • Englisch, Französisch, Dänisch und Deutsch",
  categoryNames: {
    shoes: "Schuhe",
    hoodies: "Hoodies/Sweatshirts",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen/Shorts",
    headwear: "Kopfbedeckung",
    sets: "Sets",
    underwear: "Unterwäsche",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfums",
    other: "Sonstiges",
  },
  footer: {
    disclaimer:
      "Dies ist eine unabhängige Informationsressource ohne Verbindung zu oder Sponsoring durch AllChinaBuy. Produktlinks führen zu unserer Hauptwebsite.",
    rights: "Alle Rechte vorbehalten.",
    quickLinks: "Schnellzugriff",
    categories: "Kategorien",
    resources: "Ressourcen",
    about: "Über diese Seite",
    aboutText:
      "Eine mehrsprachige Ressourcen-Hub, der dir hilft, Produktfunde, Verkäufer und Kaufreferenzen für AllChinaBuy zu organisieren.",
  },
};